export default "__VITE_ASSET__B1qRCS06__"